export default __webpack_public_path__ + "static/media/email.7f2e98f9.svg";